module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/74e1794c7821c00890a69825d7526c5e.png";